module.exports = __webpack_public_path__ + "static/media/8S.bb0023d0.svg";